exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\nhtml * {\n  font-family: 'Avenir', 'Poppins', 'sans-serif' !important;\n}\ntable.v-table thead th {\n  font-weight: bold !important;\n}\ni.mdi-magnify {\n  color: #0d73d8 !important;\n}\n", ""]);

